import { FETCH_USER_METADATA_REQUEST, FETCH_USER_METADATA_SUCCESSFUL, FETCH_USER_METADATA_ERROR } from '../actions'

const initialState = {
    countryCode: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_METADATA_REQUEST:
            return {
                ...state
            }
        case FETCH_USER_METADATA_SUCCESSFUL:
            const { countryCode } = action.payload;

            return {
                ...state,
                countryCode
            }
        case FETCH_USER_METADATA_ERROR:
            return {
                ...state,
                countryCode: null
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userMetadata.js